<template>
  <div>
    <div class="section-title">
      <h1>Nachricht schreiben</h1>
    </div>

    <div>
      <h3> Empfänger ({{ totalRecepients }})</h3>
    </div>
    <div class="flex flex-row flex-wrap">
      <div
        v-for="recepient in recepients"
        :key="recepient.name"
        class="tag"
      >
        {{ recepient.name }}&nbsp;({{ recepient.eMailAdresses.length }})
      </div>
    </div>

    <div class="mt-4">
      <h3>Nachricht</h3>
    </div>
    <input
      v-model="subject"
      type="text"
      placeholder="Betreff"
      class="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500 w-full mb-4"
    >
    <div>
      <sc-html-editor v-model="msg" />
    </div>

    <button
      class="flex-shrink-0 bg-teal-500 hover:bg-teal-700 border-teal-500 hover:border-teal-700 text-sm border-4 text-white py-1 px-2 rounded"
      type="button"
      @click="sendMail"
    >
      Absenden
    </button>
  </div>
</template>

<script>
import apiService from '../api/apiService'

export default {
    name: 'MailsWriteVue',
    data () {
        return {
            busy: false,
            teamId: '',
            msg: '',
            subject: '',
            totalRecepients: 0,
            recepients: []
        }
    },
    async mounted () {
        await this.loadTeam()
        if (this.$route.params.team) {
            this.teamId = this.$route.params.team
            const team = await this.loadTeam(this.teamId)

            this.recepients = team.members
        } else {
            this.recepients = this.$route.params.recepients
        }

        var total = 0

        for (var i = 0, _len = this.recepients.length; i < _len; i++) {
            total += this.recepients[i].eMailAdresses.length
        }

        this.totalRecepients = total
    },
    methods: {
        async loadTeam (teamId) {
            const response = await apiService.getTeam(teamId)
            return response.data
        },
        async sendMail () {
            if (!this.busy) {
                this.busy = true
                const items = this.recepients.map(x => x.id).flat().filter(x => !!x)
                console.log(items)
                await apiService.sendMail(items, this.subject, null, this.msg)
                this.busy = false
            }
        }
    }
}
</script>

<style scoped>

</style>